import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {ToastHandlerService} from '../../shared/services/toast-handler.service';
import {environment} from '../../../environments/environment';
import {catchError, map} from 'rxjs/operators';
import {throwError} from 'rxjs';
import {BackendPaginationResponse} from '../../shared/models/backend-pagination-response';
import {TranslateService} from '@ngx-translate/core';
import { BackendFilteringObject } from '../../shared/models/grid-config.interface';
import { ExportCsvService } from 'src/app/shared/services/export-csv.service';
import * as moment from 'moment';
import { AnomalyTypesGroup } from 'src/app/common-modules/common-mission/models/anomalyTypesGroup';
import { CommonMissionService } from 'src/app/common-modules/common-mission/services/common-mission.service';

@Injectable({
  providedIn: 'root'
})
export class ValetAnomalyService {

  public anomalyTypesGroups: AnomalyTypesGroup[];

  constructor(private http: HttpClient,
              private toastService: ToastHandlerService,
              private commonMissionService: CommonMissionService,
              private exportCsvService: ExportCsvService,
              private translateService: TranslateService) {
        this.anomalyTypesGroups = this.commonMissionService.getMissionAnomaliesTypesGroups();
  }

  public getAnomalies(filteringObj: BackendFilteringObject): Promise<BackendPaginationResponse<any>> {
    return this.http.get(`${environment.backendUrl}valets/anomalies?paginate=true&${filteringObj.getBackendFiltering()}`)
      .pipe(
        map((res: any) => res),
        catchError(err => {
          this.toastService.showErrorToasts(
            this.translateService.instant('modules.mission.service.get_mission_anomalies_error')
          );
          return throwError(err);
        })
      ).toPromise();
  }

  public formatMissionName(row: any): string {
    return 'M' + row.mission.id.substring(0, 8) + ' (' + row.mission.plateNumber + ')'
  }

  public formatAnomalyType(row: any): string {
    return this.anomalyTypesGroups
      .flatMap(g => g.types)
      .find(t => t.value === row.type)?.name || '';
  }
  
  public formatAnomalyComment(row: any): string {
    return row.comment ? row.comment.replace(/\n/g, '<br>') : '';
  }

  public formatAnomalyDocument(row: any): string {
    return (row && row.url) ? `<a href="${row.url}" target="_blank">${this.translateService.instant('modules.mission.mission_anomaly_grid.document')}</a>` : '';
  }

  public formatAnomalyDate(row: any): string {
    return moment(row.date).format('DD.MM.YYYY HH:mm:ss');
  }

  public exportValetAnomaliesPageData(localData: any[]): Promise<any> {
    try {
      let formattedExport = this.exportValetAnomaliesParser(localData);
      this.exportCsvService.export(formattedExport);
      return Promise.resolve(formattedExport);
    } catch (error) {
      this.toastService.showErrorToasts(
        this.translateService.instant('admin.modules.valet.services.valet.export_valet_anomalies_error')
      );
      return Promise.reject(error);
    }
  }

  private exportValetAnomaliesParser(dataToExport: any[]): any[] {
    const formattedExport = [];
    dataToExport.forEach(row => {
      formattedExport.push({
        'Id Mission': this.formatMissionName(row),
        'Type': this.formatAnomalyType(row),
        'Commentaire': this.formatAnomalyComment(row),
        'Documents': this.formatAnomalyDocument(row),
        'Date': this.formatAnomalyDate(row)
      });
    });
    this.exportCsvService.export(formattedExport);
    return formattedExport;
  }
}
